import { appBaseUrl } from "utils/config";
import { getService, postService, putService } from "services/commonServices";
import { isEmpty } from "lodash";
import queryString from "query-string";

export class SowAbbrService {
  // Fetch the listing of SowAbbr
  getSowAbbrListing() {
    let url = `${appBaseUrl}/referenceManagement/sowAbbrList`;

    try {
      const data = getService(url);
      return data;
    } catch (error) {
      // console.error("Error fetching SowAbbr listing:", error);
      throw error;
    }
  }

  // Fetch paginated list of SowAbbr
  getSowAbbrPaginationListNew(body) {
    const query = queryString.stringify(body);
    let url = `${appBaseUrl}/referenceManagement/sowAbbrFilterList?${query}`;
    let data = getService(url, body);
    return data;
  }

  // Create a new SowAbbr entry
  createSowAbbr(body) {
    let url = `${appBaseUrl}/referenceManagement/sowAbbr`;
    let data = postService(url, body);
    return data;
  }

  // Update an existing SowAbbr entry
  updateSowAbbr(body) {
    let url = `${appBaseUrl}/referenceManagement/updateSowAbbr`;
    let data = postService(url, body);
    return data;
  }
}
